// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"c43411c8","821":"c1d34e5b"}[chunkId] + ".chunk.js";
};